(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glownovi-bundle-sizes"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = scope => {
      scope.querySelectorAll('[data-gn-bundle-sizes]').forEach(root => {
        const form = root.querySelector('[data-gn-size-form]');
        if (!form || root.dataset.bound) return;
        let data;
        try { data = JSON.parse(root.querySelector('[data-gn-size-data]').textContent); } catch (_) { return; }
        if (!Array.isArray(data.components) || data.components.length !== 3 || !data.parentVariantId) return;
        root.dataset.bound = 'true';
        const abort = new AbortController();
        const button = form.querySelector('[data-gn-size-add]');
        const buttonText = form.querySelector('[data-gn-size-add-text]');
        const quantity = form.querySelector('[data-gn-set-quantity]');
        const status = form.querySelector('[data-gn-size-status]');
        const cartLink = form.querySelector('[data-gn-review-cart]');
        const page = root.closest('[data-gn-conversion]');
        const localeRoot = window.Shopify?.routes?.root || '/';
        const strings = data.strings;
        let pending = false;
        let uncertain = false;
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: data.currency }).format(cents / 100);
        const selected = () => data.components.map(component => {
          const group = form.querySelector('[data-gn-component="' + component.key + '"]');
          const checked = group?.querySelector('input:checked');
          const id = group ? Number(checked?.value) : component.initial;
          return { component, variant: component.variants.find(variant => variant.id === id) };
        });
        const isValid = (selection, count) => {
          const rule = data.parentRule || { min: 1, increment: 1, max: null };
          return Number.isSafeInteger(count) && count > 0 && count >= rule.min && count % rule.increment === 0 && (!rule.max || count <= rule.max) && data.parentAvailable && selection.every(({ variant }) => variant?.available && !variant.requiresSellingPlan);
        };
        const refresh = () => {
          const selection = selected();
          const count = Number(quantity.value);
          form.querySelector('[data-gn-set-total]').textContent = money(data.parentPrice * (Number.isSafeInteger(count) && count > 0 ? count : 1));
          page?.querySelectorAll('[data-lm-pdp-price], [data-gn-sticky-price]').forEach(element => { element.textContent = money(data.parentPrice); });
          data.components.forEach(component => {
            const group = form.querySelector('[data-gn-component="' + component.key + '"]');
            if (!group) return;
            const variant = selection.find(item => item.component === component).variant;
            group.querySelector('[data-gn-choice]').textContent = variant?.title || strings.chooseSize;
            group.querySelectorAll('input').forEach(input => {
              const option = component.variants.find(item => item.id === Number(input.value));
              input.disabled = pending || !option?.available;
              input.closest('label').classList.toggle('is-unavailable', !option?.available);
            });
          });
          const available = data.parentAvailable && data.components.every(component => component.variants.some(variant => variant.available && !variant.requiresSellingPlan));
          const stock = page?.querySelector('[data-lm-pdp-stock]');
          const stockText = page?.querySelector('[data-lm-pdp-stock-text]');
          if (stock) stock.classList.toggle('is-sold-out', !available);
          if (stockText) stockText.textContent = available ? strings.inStock : strings.soldOut;
          const eta = page?.querySelector('[data-lm-pdp-eta]');
          if (eta) eta.hidden = !available;
          button.disabled = pending || uncertain || !isValid(selection, count);
          button.setAttribute('aria-busy', String(pending));
          buttonText.textContent = pending ? strings.adding : available ? strings.add : strings.soldOut;
          quantity.disabled = pending;
          if (!available && !pending && !uncertain) status.textContent = strings.unavailable;
          return { selection, count, valid: isValid(selection, count) };
        };
        const announce = (message, review = false) => {
          status.textContent = message;
          cartLink.hidden = !review;
          status.focus({ preventScroll: true });
        };
        const readJson = async response => {
          const result = await response.json();
          if (!response.ok) throw new Error('request');
          return result;
        };
        form.addEventListener('change', () => { if (!pending && !uncertain) { status.textContent = ''; cartLink.hidden = true; refresh(); } }, { signal: abort.signal });
        quantity.addEventListener('input', () => { if (!pending && !uncertain) refresh(); }, { signal: abort.signal });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (pending || uncertain) return;
          const before = refresh();
          if (!before.valid || !form.reportValidity()) { announce(strings.choose); return; }
          pending = true;
          status.textContent = '';
          cartLink.hidden = true;
          refresh();
          let priceChanged = false;
          try {
            const products = await Promise.all([...data.components.map(component => component.handle), data.parentHandle].map(handle => fetch(localeRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' }).then(readJson)));
            products.slice(0, 3).forEach((product, index) => {
              data.components[index].variants.forEach(variant => {
                const live = product.variants?.find(item => item.id === variant.id);
                variant.available = Boolean(live?.available) && live?.title === variant.title;
                variant.requiresSellingPlan = Boolean(live?.requires_selling_plan);
                if (live) variant.sku = live.sku;
              });
            });
            const parent = products[3].variants?.find(variant => variant.id === data.parentVariantId);
            data.parentAvailable = Boolean(parent?.available) && !parent?.requires_selling_plan;
            if (!parent || !Number.isSafeInteger(parent.price)) throw new Error('parent');
            priceChanged = parent.price !== data.parentPrice;
            data.parentPrice = parent.price;
            data.parentRule = parent.quantity_rule || { min: 1, increment: 1, max: null };
          } catch (_) {
            pending = false;
            refresh();
            announce(strings.preflightFailed);
            return;
          }
          const current = refresh();
          if (priceChanged || !current.valid) {
            pending = false;
            refresh();
            announce(priceChanged ? strings.priceChanged : strings.unavailable);
            return;
          }
          const attempt = window.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
          const properties = {
            _gn_bundle_attempt: attempt,
            _gn_bundle_components: JSON.stringify(current.selection.map(({ component, variant }) => ({ variant_id: variant.id, sku: variant.sku, quantity_per_set: component.quantity })))
          };
          current.selection.forEach(({ component, variant }) => {
            if (!form.querySelector('[data-gn-component="' + component.key + '"]')) return;
            const name = component.key === 'a' ? strings.boyshort : form.querySelector('input[name="highwaist_size"]') ? strings.highwaist : strings.flange;
            properties[name] = variant.title;
          });
          const item = { id: data.parentVariantId, quantity: current.count, properties };
          try {
            const response = await fetch(localeRoot + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
            if (!response.ok) {
              uncertain = true;
              pending = false;
              refresh();
              announce(strings.failed, true);
              return;
            }
            const cart = await readJson(await fetch(localeRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }));
            if (!Array.isArray(cart.items)) throw new Error('cart');
            const added = cart.items.filter(line => line.properties?._gn_bundle_attempt === attempt);
            if (added.length !== 1 || added[0].variant_id !== item.id || added[0].quantity !== item.quantity || Object.entries(item.properties).some(([key, value]) => added[0].properties?.[key] !== value)) throw new Error('selection');
            window.location.assign(data.cartUrl);
          } catch (_) {
            uncertain = true;
            pending = false;
            refresh();
            announce(strings.uncertain, true);
          }
        }, { signal: abort.signal });
        refresh();
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) abort.abort(); }, { signal: abort.signal });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document), { once: true });
    else bind(document);
    document.addEventListener('shopify:section:load', event => bind(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
